import { Component, Inject, ViewEncapsulation } from '@angular/core';

import SwiperCore, { Autoplay, Keyboard, Navigation, Pagination, SwiperOptions } from 'swiper';
import { ApplicationFacade } from '@ridango/components';
import { AuthService } from '@ridango/core';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import Env from '@ridango/core/env';

import { HelperService } from '../../../shared/services/helper.service';

SwiperCore.use([Pagination, Autoplay, Keyboard, Navigation]);

@Component({
    selector: 'gl-home-page-stw',
    templateUrl: './home-page-stw.component.html',
    styleUrls: ['./home-page-stw.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomePageStwComponent {
    themeFeature = ThemeFeature;
    assetsPath$ = this.applicationFacade.assetsPath$;

    countySliderConf: SwiperOptions = {
        slidesPerView: 3,
        spaceBetween: 10,
        speed: 1500,
        keyboard: {
            enabled: true
        },
        pagination: { clickable: true },
        autoplay: { delay: 2500 },
        breakpoints: {
            '768': {
                slidesPerView: 5
            }
        }
    };

    noticesSliderConf: SwiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 30,
        speed: 1500,
        navigation: {
            nextEl: '.swiper-navigation-button--next',
            prevEl: '.swiper-navigation-button--prev',
            disabledClass: 'opacity-50'
        },
        keyboard: {
            enabled: true
        },
        pagination: { clickable: true },
        breakpoints: {
            '768': {
                slidesPerView: 2
            },
            '1024': {
                slidesPerView: 3,
                spaceBetween: 60
            }
        }
    };

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env,
        public ridangoAuth: AuthService,
        public helperService: HelperService
    ) {}

    getAllowedLinks(links) {
        return links.filter((item) => this.helperService.isAllowedPath(item.link));
    }
}
